// The house style panel's data (2026-11-02, server/src/ai/house-style.js):
// which template root a folder belongs to, and the profile as labeled rows
// for Settings -> Templates. Read-only: the profile is derived from the
// root's own templates on the server.

export const HOUSE_STYLE_ROOTS = Object.freeze(['1A eBay', 'AM eBay', '1A Website', 'AM Website', '1A Support', 'AM Support'])

// "1A eBay/Pre Fit" -> "1A eBay"; null for a folder outside the six roots.
export function houseStyleRootOfFolder(folder) {
  const root = String(folder ?? '').split('/')[0].trim()
  return HOUSE_STYLE_ROOTS.find((r) => r.toLowerCase() === root.toLowerCase()) ?? null
}

const NONE = 'none'
const FIELD_LABELS = Object.freeze({
  format: 'Format',
  greeting: 'Greeting',
  headers: 'Section headers',
  referenceId: 'Reference ID line',
  partLines: 'Part lines',
  fitCheck: 'Fit check line',
  dontCarry: '"We don\'t carry it" wording',
  vinAsk: 'VIN ask',
  oos: 'Out-of-stock note',
  moreInfo: 'More information line',
  signature: 'Signature',
})

// [{ key, label, value }] in display order. value is a string ('none' when
// the profile has no value).
export function houseStyleRows(profile) {
  if (!profile) return []
  const p = profile
  const oos = [p.oos?.withEta, p.oos?.noEta, p.oos?.watchlist].filter(Boolean)
  return [
    { key: 'format', value: p.format === 'html' ? `HTML${p.headerStyle === 'bold' ? ', bold section headers' : ''}` : p.format === 'plain' ? 'Plain text' : NONE },
    { key: 'greeting', value: p.greeting ?? NONE },
    { key: 'headers', value: p.headers?.length ? p.headers.join(' · ') : NONE },
    { key: 'referenceId', value: p.referenceId ?? NONE },
    { key: 'partLines', value: p.partLines?.length ? p.partLines.map((l) => `${p.partBullet ? `${p.partBullet} ` : ''}${l.text}`).join('\n') : NONE },
    { key: 'fitCheck', value: p.fitCheck ?? NONE },
    { key: 'dontCarry', value: p.dontCarry?.length ? p.dontCarry.join(' ') : NONE },
    { key: 'vinAsk', value: p.vinAsk ?? NONE },
    { key: 'oos', value: oos.length ? oos.join('\n') : NONE },
    { key: 'moreInfo', value: p.moreInfo ?? NONE },
    { key: 'signature', value: p.signature ?? NONE },
  ].map((r) => ({ ...r, label: FIELD_LABELS[r.key] }))
}

// The fields with no clear majority, by label ("Greeting", "Part lines
// (warranty)").
export function unresolvedLabels(profile) {
  return (profile?.unresolved ?? []).map((f) => {
    const [field, sub] = String(f).split('.')
    const label = FIELD_LABELS[field] ?? field
    return sub ? `${label} (${sub.replace('_', '-')})` : label
  })
}
